import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import AlterationForm from "../ui/alteration_forms/AlterationForm";
import AlterationFormsList from "../ui/alteration_forms/AlterationFormsList";

const AlterationFormRoutes = (
  <Route
    path={AppSections.ALTERATION_FORMS}
    element={
      <ProtectedRoute>
        <AlterationForm />
      </ProtectedRoute>
    }
  >
    <Route path="/alteration-forms/" element={<AlterationFormsList />} />
  </Route>
);

export default AlterationFormRoutes;